"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuReducer = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
// const initialState: ProfiloMenuDto = ProfiloMenuDtoFromJSON({});
const initialState = {
    profiloMenu: (0, api_rest_1.ProfiloMenuDtoFromJSON)({}),
    textSearch: '',
    smartOtpEnrolledUsername: '',
    notificheMenu: undefined
};
const menuReducer = (state = initialState, action) => {
    switch (action.type) {
        case __1.EReduxActionTypes.MENU_GET_MENU_SUCCESS:
            return {
                ...state,
                profiloMenu: action.payload
            };
        case __1.EReduxActionTypes.MENU_GET_MENU_SUCCESS_MOBILE:
            return {
                ...state,
                profiloMenu: action.payload
            };
        case __1.EReduxActionTypes.MENU_GET_TAGS_SUCCESS:
            return {
                ...state,
                profiloMenu: {
                    ...state.profiloMenu,
                    tags: action.payload
                }
            };
        case __1.EReduxActionTypes.MENU_GET_NOTIFICHE_MENU_SUCCESS:
            return {
                ...state,
                notificheMenu: action.payload
            };
        case __1.EReduxActionTypes.LOGOUT_SUCCESS:
            return {
                ...initialState
            };
        case __1.EReduxActionTypes.MENU_SET_TEXT_SEARCH:
            return {
                ...state,
                textSearch: action.payload
            };
        case __1.EReduxActionTypes.MENU_RESET_TEXT_SEARCH:
            return {
                ...state,
                textSearch: ''
            };
        // case EReduxActionTypes.MENU_SET_MENU_NOTIFICHE_PUSH_ABILITATO:
        //   const profiloMenu: ProfiloMenuDto = { ...state.profiloMenu };
        //   profiloMenu.profiloItems?.find((item: ProfiloMenu) => item.id === 'menu.gestione_utente')?.submenu?.push({
        //     id: 'menu.notifiche_push',
        //     label: 'menu.notifiche_push'
        //   })
        //   return {
        //     ...state,
        //     profiloMenu: profiloMenu
        //   };
        case __1.EReduxActionTypes.MENU_SET_SMART_OTP_ENROLLED_USERNAME:
            // const profiloMenu: ProfiloMenuDto = { ...state.profiloMenu };
            // profiloMenu.profiloItems?.find((item: ProfiloMenu) => item.id === 'menu.gestione_utente')?.submenu?.push({
            //   id: 'menu.notifiche_push',
            //   label: 'menu.notifiche_push'
            // })
            return {
                ...state,
                smartOtpEnrolledUsername: action.payload,
                // profiloMenu: profiloMenu
            };
        // case EReduxActionTypes.MENU_SET_MENU_NOTIFICHE_PUSH_ABILITATO:
        //   const profiloMenu: ProfiloMenuDto = { ...state.profiloMenu };
        //   profiloMenu.profiloItems?.find((item: ProfiloMenu) => item.id === 'menu.gestione_utente')?.submenu?.push({
        //     id: 'menu.notifiche_push',
        //     label: 'menu.notifiche_push'
        //   })
        //   console.log('profiloMenu', profiloMenu)
        //   return {
        //     ...state,
        //     // smartOtpEnrolledUsername: action.payload,
        //     profiloMenu: profiloMenu
        //   };
        case __1.EReduxActionTypes.RESET_ALL: // action invocata dalla logout
            return {
                ...initialState
            };
        default:
            return state;
    }
};
exports.menuReducer = menuReducer;
exports.default = exports.menuReducer;
